<template>
    <div>
        <div class="stock">
            <ul v-show="isList">
                <li
                    v-for="(item,index) in list"
                    :key="index"
                >
                    <stockItem
                        ref="stockitem"
                        :item="item"
                        @changeState="changeState"
                        @showInfo="showInfo"
                    />
                </li>
            </ul>
            <!-- loading效果 -->
            <div
                class="loading"
                v-if="isLoading"
            >
                <i class="material-icons">cached</i>
            </div>
            <!-- 无数据时显示的背景 -->
            <div
                class="background"
                v-else-if="!isList"
            >
                <img
                    src="http://static.unicornselected.com/d193e7c0-837e-11e9-860b-615b4aee42ab.png"
                    alt
                />
                <p>{{en?'There is no data on this page. Go ahead and add it':'该页面还未有数据赶快去添加吧'}}</p>
            </div>

            <a
                class="waves-effect waves-light btn red"
                @click="toPickCom"
                v-if="!isLoading"
            >{{en?'Add':'添加'}}</a>
        </div>
        <div
            class="mask"
            v-show="state || stock || pickCom"
            @click="hideDialog"
        ></div>
        <div
            class="dialog"
            v-show="pickCom"
        >
            <chooseCom @toAddStock="addStock"></chooseCom>
        </div>
        <div v-if="stock">
            <StockDialog
                @closed="closeStock"
                @submited="submited"
                ref="stockDialog"
            ></StockDialog>
        </div>
    </div>
</template>

<script>
import { HttpClient } from '../util/http.js';
import { peopleDetail } from '../components/dialog/peopleDetail';
import peopleDetailVue from '../components/dialog/peopleDetail.vue';
import { NumberUtil } from '../util/number';
import stockItem from '../components/stock/stockItem';
import chooseCom from '../components/stock/chooseCom';
import StockDialog from '../components/dialog/StockDialog.vue';
export default {
    data() {
        return {
            list: [],
            state: false, //修改数据弹框
            company: {},
            stocks: [],
            pickCom: false, //选择公司弹框
            stock: false,
            isLoading: false,
        };
    },
    components: {
        chooseCom,
        StockDialog,
        stockItem,
    },
    computed: {
        isList() {
            return this.list.length > 0;
        },
        en() {
            return location.pathname.indexOf('/en') == -1 ? '' : '/en';
        },
    },
    wactch: {},
    methods: {
        addStock(company) {
            this.pickCom = false;
            this.stock = true;
            this.$nextTick(() => {
                this.$refs.stockDialog.init({
                    company: company,
                    type: 'option',
                });
            });
        },
        toPickCom() {
            this.pickCom = true;
        },
        async showInfo() {
            this.isLoading = true;
            const res = await HttpClient.get('/stock/mine');
            this.list = res;
            // console.log(res)
            this.isLoading = false;
        },
        showDialog({ company, stocks }) {
            this.state = true;
            this.company = company;
            this.stocks = stocks[0];

            // console.log(this.stocks);
        },
        async hideDialog() {
            for (let i = 0; i < this.$refs.stockitem.length; i++) {
                this.$refs.stockitem[i].closeAll();
            }
            const res = await HttpClient.get('/stock/mine');
            this.list = res;
            this.state = false;
            this.stock = false;
            this.pickCom = false;
        },
        closeStock() {
            this.stock = false;
        },
        submited(stock) {
            this.stock = false;
            this.showInfo();
        },
        // 控制mask
        changeState(state) {
            this.state = state;
            // console.log(this.state);
        },
    },
    created() {
        this.showInfo();
    },
    mounted() {
        M.AutoInit();
    },
};
</script>

<style lang="less" scoped>
.stock {
    max-width: 1000px;
    margin: 30px auto;
    font-size: 16px;
    ul {
        margin: 0;
        padding: 0;
        .stock_item {
            border-radius: 5px;
            box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.1),
                0 1px 2px 0 rgba(0, 0, 0, 0.1);
            background-color: #fff;
            margin-bottom: 20px;
            header {
                height: 50px;
                line-height: 50px;
                font-size: 20px;
                text-align: left;
                padding-left: 50px;
            }
            .tabs {
                border-top: 1px solid #ddd;
                border-bottom: 1px solid #ddd;
                // .active {
                //     a {
                //         font-size: 16px;
                //         color: #bc242b;
                //         border-bottom: 3px solid #bc242b;
                //     }
                // }
                a {
                    color: #000;
                    font-size: 16px;
                }
                i {
                    display: block;
                    width: 20px;
                    height: 20px;
                }
            }
            #test1,
            #test2 {
                padding: 20px 0;
                border-bottom: 1px solid #ddd;
                li {
                    div {
                        width: 150px;
                        height: 20px;
                        margin: 0 auto;
                        img {
                            float: left;
                            width: 20px;
                        }
                        span {
                            float: right;
                            width: 100px;
                            text-align: left;
                        }
                    }
                }
            }
            .active {
                color: #bc242b;
                border-bottom: 1px solid #bc242b;
            }
            .edit {
                height: 30px;
                padding-right: 30px;
                img {
                    float: right;
                    width: 20px;
                }
            }
        }
    }
    .background {
        width: 700px;
        margin: 200px auto 50px;
        img {
            width: 500px;
        }
    }
    .btn {
        width: 200px;
    }
    .edit_dialog {
        width: 1300px;
        border-radius: 5px;
        box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.1),
            0 1px 2px 0 rgba(0, 0, 0, 0.1);
        position: fixed;
        top: 300px;
        z-index: 999;
        background-color: #fff;
        h5 {
            padding-left: 100px;
            line-height: 50px;
            text-align: left;
            border-bottom: 1px solid #ccc;
        }
        table {
            th,
            td {
                width: 20%;
                text-align: center;
                img {
                    margin-left: 10px;
                }
            }
        }
    }
}
.loading {
    @keyframes rotate-loading {
        to {
            transform: rotate(360deg);
        }
    }
    i {
        color: #bc242b;
        font-size: 50px;
        animation: rotate-loading 0.7s linear infinite;
    }
}
.dialog {
    position: fixed;
    top: 100px;
    z-index: 1000;
    background-color: #fff;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 5px;
}
.mask {
    position: fixed;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 1000px;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>
